import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { myConstants } from '../../shares/Constants'
import {setAuthToken} from './AuthSlice'

export const AuthApi = createApi({
  reducerPath: 'AuthApi',
  baseQuery: fetchBaseQuery({
    // Fill in your own server starting URL here
    baseUrl: myConstants.baseURL,
    prepareHeaders: (headers, { getState }) => 
    {        
      const token = getState().auth.token;
      // console.log("prepare-header:" + token);
      if (token) 
      {
        headers.set('Authorization', `token ${token}`);
      }
      return headers;      
    },    
  }),
  endpoints: (build) => ({
    loginUser: 
      build.mutation(
        {
          query: (credentials) => ({
            url: myConstants.endpoints.user.login,
            method: 'POST',
            body : credentials
          }),
          async onQueryStarted( credentials, { dispatch, queryFulfilled } )
          {
            try 
            {
              const { data } = await queryFulfilled;
              // console.log(data.token);
              dispatch(setAuthToken(data.token));
            } 
            catch(error) 
            {              
              // console.log(error);
              dispatch(setAuthToken(null));
            }
          },
        }
      ),
    
    getProfile: 
      build.query(
        {
          query: () => ({
            url: myConstants.endpoints.user.profile,
            method: 'POST',
          })
        }
      )
  }),
})

export const { useLoginUserMutation, useGetProfileQuery, useLazyGetProfileQuery, usePrefetch } = AuthApi